import React, { useState, useRef, useEffect } from 'react';
import styles from './AutocompleteTextarea.module.css';
import { useAuth } from '../../../../contexts/AuthContext';
import {
  API_ENDPOINTS,
  HTTP_METHODS,
} from '../../../../constants/appConstants';
import { apiRequest } from '../../../../constants/apiRequest';

/*const suggestionsList = [
  "change the background color to red",
  "change font color to blue",
  "change font size",
  "change font family to arial",
  "replace the text from",
  "change border, margin, padding : buttons, input box",
  "add new block",
  "add/change placeholder in input field",
  "replace image with image_url",
  "enhance layout of this template"
];*/

const AutocompleteTextarea = ({
  userPrompt,
  setUserPrompt,
  showSuggestion,
  onSuggestionToggle,
}) => {
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [previousPrompt, setPreviousPrompt] = useState('');
  const [prompt, setPrompt] = useState(false);
  const [isSuggestion, setIsSuggestion] = useState(false);
  const containerRef = useRef(null);
  const textareaRef = useRef(null);
  const { token, handleLogout } = useAuth();
  const [apiPrompts, setApiPrompts] = useState([]);

  const getPrompts = async () => {
    const savedPromptsResponse = await apiRequest(
      API_ENDPOINTS.PROMPT_LIST,
      HTTP_METHODS.POST,
      { deletedAt: 'null' },
      token,
      handleLogout
    );

    if (savedPromptsResponse.success) {
      return savedPromptsResponse.data; // Assuming API returns an array of prompts
    }
    return [];
  };
  useEffect(() => {
    const fetchSuggestions = async () => {
      const fetchedPrompts = await getPrompts();
      if (fetchedPrompts) {
        setApiPrompts(fetchedPrompts);
      }
    };

    fetchSuggestions();
  }, [showSuggestion]); // ✅ Runs only once when the component mounts

  useEffect(() => {
    if (userPrompt.length > 0 && !showSuggestion) {
      if (userPrompt === previousPrompt) return; // Prevent execution if userPrompt is the same

      setPreviousPrompt(userPrompt);

      //  const apiPrompts = await getPrompts();
      const extractedPrompts = apiPrompts.map(
        ({ prompt_name, prompt_description }) => ({
          prompt_name,
          prompt_description,
        })
      );

      const promptNames = extractedPrompts.map(
        ({ prompt_name }) => prompt_name
      );
      let filtered = promptNames.filter((sugg) =>
        sugg.toLowerCase().includes(userPrompt.toLowerCase())
      );
      //If no suggestions are found then return all list
      if (filtered.length === 0 && userPrompt.trim() !== '') {
        filtered = promptNames;
      }
      setFilteredSuggestions(filtered);
      if (isSuggestion) {
        setShowSuggestions(filtered.length > 0);
      }

      /*const filtered = suggestionsList.filter((sugg) =>
        sugg.toLowerCase().includes(userPrompt.toLowerCase())
      );
      setFilteredSuggestions(filtered);
      if (isSuggestion) {
        setShowSuggestions(filtered.length > 0);
      }*/
    } else {
      if (showSuggestion && !prompt) {
        const extractedPrompts = apiPrompts.map(
          ({ prompt_name, prompt_description }) => ({
            prompt_name,
            prompt_description,
          })
        );
        const promptNames = extractedPrompts.map(
          ({ prompt_name }) => prompt_name
        );

        setFilteredSuggestions(promptNames);
        setShowSuggestions(true);
      }
      //Added to fix view prompt issue
      if (prompt && userPrompt.length <= 0) {
        const extractedPrompts = apiPrompts.map(
          ({ prompt_name, prompt_description }) => ({
            prompt_name,
            prompt_description,
          })
        );
        const promptNames = extractedPrompts.map(
          ({ prompt_name }) => prompt_name
        );
        setFilteredSuggestions(promptNames);
        setShowSuggestions(true);
      }
    }
  }, [
    userPrompt,
    showSuggestion,
    apiPrompts,
    onSuggestionToggle,
    previousPrompt,
  ]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowSuggestions(false);
        if (showSuggestion) {
          onSuggestionToggle(false);
        }
      } else {
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onSuggestionToggle]);

  const handleChange = (e) => {
    setIsSuggestion(true);
    setPrompt(true);
    setUserPrompt(e.target.value);
  };

  const handleSuggestionClick = (suggestion) => {
    setPrompt(true);
    setIsSuggestion(false);
    onSuggestionToggle(false);
    setUserPrompt(suggestion);
    setShowSuggestions(false);
    textareaRef.current.focus();
  };

  return (
    <div className={styles.autoCompleteContainer} ref={containerRef}>
      <textarea
        ref={textareaRef}
        value={userPrompt}
        onChange={handleChange}
        placeholder="Describe additional changes (e.g., make h1 text larger)"
        className={styles.textArea}
      />

      {(showSuggestions || showSuggestion) && (
        <ul className={styles.suggestionsList}>
          {filteredSuggestions.map((suggestion, index) => (
            <li
              key={index}
              onClick={() => handleSuggestionClick(suggestion)}
              className={styles.suggestionItem}
            >
              {suggestion}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AutocompleteTextarea;
